// extracted by mini-css-extract-plugin
export default {"icon":"UpdatesContext_icon__sEMdJ"};